import axios from '../../config/AxiosConfig'; // Chemin corrigé

// Actions pour les messages
export const setMessage = (message) => ({
  type: 'SET_MESSAGE',
  payload: message
});

export const clearMessage = () => ({
  type: 'CLEAR_MESSAGE'
});

// Charger le client connecté
export const loadClient = () => async (dispatch) => {
  try {
    const token = localStorage.getItem('clientToken');
    
    if (!token) {
      return { success: false, message: 'Aucun token trouvé' };
    }

    // Configuration axios avec le token
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // Récupérer le profil client
    const { data } = await axios.get('/api/client/auth/profile');

    if (data.success) {
      dispatch({
        type: 'CLIENT_LOAD_SUCCESS',
        payload: data.client
      });

      // Charger les points séparément
      await dispatch(getClientPoints(data.client._id));
      
      return { success: true, client: data.client };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    console.error('Erreur chargement client:', error);
    
    // Si le token est invalide, déconnecter
    if (error.response?.status === 401) {
      dispatch(logoutClient());
    }
    
    return { 
      success: false, 
      message: error.response?.data?.message || 'Erreur chargement profil' 
    };
  }
};

// Connexion client
export const loginClient = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: 'CLIENT_LOGIN_REQUEST' });

    console.log('🔐 Tentative connexion:', { email });

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const { data } = await axios.post('/api/client/auth/login', {
      email,
      password
    }, config);

    console.log('✅ Réponse backend login:', data);

    if (data.success) {
      dispatch({
        type: 'CLIENT_LOGIN_SUCCESS',
        payload: {
          client: data.client,
          token: data.token
        }
      });

      // Sauvegarder le token
      localStorage.setItem('clientToken', data.token);
      localStorage.setItem('clientData', JSON.stringify(data.client));
      
      // Configurer axios pour les futures requêtes
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

      // Charger les points du client
      await dispatch(getClientPoints(data.client._id));

      dispatch(setMessage({
        type: 'success',
        text: data.message || 'Connexion réussie !'
      }));

      return { success: true, data };
    } else {
      console.error('❌ Backend login a retourné success: false:', data);
      throw new Error(data.message || 'Erreur de connexion');
    }
    
  } catch (error) {
    console.error('❌ Erreur complète login:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      url: error.config?.url
    });
    
    const errorMessage = error.response?.data?.message || 
                       error.response?.data?.error ||
                       error.message || 
                       'Email ou mot de passe incorrect';
    
    dispatch({
      type: 'CLIENT_LOGIN_FAIL',
      payload: errorMessage
    });

    dispatch(setMessage({
      type: 'error',
      text: `Erreur: ${errorMessage}`
    }));

    return { success: false, message: errorMessage };
  }
};

// Inscription client
export const registerClient = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: 'CLIENT_REGISTER_REQUEST' });

    console.log('🔍 Données envoyées au backend:', {
      ...clientData,
      password: '***' // Masquer le mot de passe dans les logs
    });

    // AJOUTER des headers explicitement
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const { data } = await axios.post('/api/client/auth/register', clientData, config);

    console.log('✅ Réponse backend:', data);

    if (data.success) {
      dispatch({
        type: 'CLIENT_REGISTER_SUCCESS',
        payload: {
          client: data.client,
          token: data.token
        }
      });

      localStorage.setItem('clientToken', data.token);
      localStorage.setItem('clientData', JSON.stringify(data.client));
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

      // Charger les points
      await dispatch(getClientPoints(data.client._id));

      dispatch(setMessage({
        type: 'success',
        text: data.message || 'Inscription réussie !'
      }));

      return { success: true, data };
    } else {
      console.error('❌ Backend a retourné success: false:', data);
      throw new Error(data.message || 'Erreur lors de l\'inscription');
    }
    
  } catch (error) {
    console.error('❌ Erreur complète inscription:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers
    });
    
    const errorMessage = error.response?.data?.message || 
                       error.response?.data?.error ||
                       error.message || 
                       'Erreur lors de l\'inscription';
    
    dispatch({
      type: 'CLIENT_REGISTER_FAIL',
      payload: errorMessage
    });

    dispatch(setMessage({
      type: 'error',
      text: `Erreur: ${errorMessage}`
    }));

    return { success: false, message: errorMessage };
  }
};


// Récupérer les points du client
export const getClientPoints = (clientId) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_POINTS_REQUEST' });

    const { data } = await axios.get(`/api/client/points/points`);

    if (data.success) {
      dispatch({
        type: 'GET_POINTS_SUCCESS',
        payload: data
      });

      // Mettre à jour localStorage
      localStorage.setItem('clientPoints', data.points);

      return { success: true, data };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur récupération points';
    
    dispatch({
      type: 'GET_POINTS_FAIL',
      payload: errorMessage
    });
    
    // Points par défaut en cas d'erreur
    const defaultPoints = parseInt(localStorage.getItem('clientPoints')) || 0;
    dispatch({
      type: 'UPDATE_POINTS',
      payload: defaultPoints
    });
    
    return { success: false, message: errorMessage };
  }
};

// Ajouter des points via QR Code
// ClientActions.js - MODIFIEZ la fonction addPointsFromQR
export const addPointsFromQR = (qrData) => async (dispatch) => {
    try {
        dispatch({ type: 'ADD_POINTS_REQUEST' });

        const token = localStorage.getItem('clientToken');
        
        console.log('🔍 DEBUG addPointsFromQR - QR Data reçu:', qrData);
        
        if (!token) {
            throw new Error('Non authentifié. Veuillez vous connecter.');
        }

        // FORMATER les données selon ce qu'attend le backend
        const requestData = {
            qrCode: qrData.code || qrData.qrCode || qrData.rawData, // Le code QR lui-même
            points: qrData.points || 0,
            billNumber: qrData.billNumber || '',
            location: qrData.location || 'SPINTOSS',
            items: qrData.items || [],
            qrType: qrData.type || 'UNKNOWN',
            isLocalQRCode: false, // Par défaut
            rawQRData: qrData.rawData || JSON.stringify(qrData)
        };

        // Détecter si c'est un code local KdoXXX
        if (requestData.qrCode && (
            requestData.qrCode.startsWith('Kdo') || 
            requestData.qrCode.startsWith('KDO') ||
            (qrData.type && qrData.type.includes('KDO'))
        )) {
            requestData.isLocalQRCode = true;
            console.log('✅ Code local détecté:', requestData.qrCode);
        }

        console.log('📤 Données envoyées au backend:', requestData);

        const response = await fetch('/api/client/points/add-points', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(requestData)
        });

        console.log('📥 Réponse du serveur - Status:', response.status);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Erreur serveur:', errorText);
            
            let errorMessage = 'Erreur lors de l\'ajout des points';
            try {
                const errorData = JSON.parse(errorText);
                errorMessage = errorData.message || errorMessage;
            } catch (e) {
                // Pas un JSON
            }
            
            throw new Error(errorMessage);
        }

        const data = await response.json();
        console.log('✅ Réponse du backend:', data);

        if (!data.success) {
            throw new Error(data.message || 'Erreur inconnue');
        }

        // SUCCÈS - Mettre à jour le store
        dispatch({
            type: 'ADD_POINTS_SUCCESS',
            payload: data
        });

        // Mettre à jour les points dans le store
        dispatch({
            type: 'UPDATE_POINTS',
            payload: data.newPoints
        });

        localStorage.setItem('clientPoints', data.newPoints);

        // Mettre à jour les infos client
        const storedClient = localStorage.getItem('clientData');
        if (storedClient) {
            const clientObj = JSON.parse(storedClient);
            const updatedClient = {
                ...clientObj,
                points: data.newPoints,
                level: data.newLevel || clientObj.level
            };
            localStorage.setItem('clientData', JSON.stringify(updatedClient));
            
            dispatch({
                type: 'UPDATE_CLIENT_PROFILE',
                payload: updatedClient
            });
        }

        return {
            success: true,
            data: data,
            pointsAdded: data.pointsAdded
        };

    } catch (error) {
        console.error('❌ Erreur addPointsFromQR:', error);
        
        dispatch({
            type: 'ADD_POINTS_FAIL',
            payload: error.message
        });

        return {
            success: false,
            message: error.message
        };
    }
};
// Ajouter des points manuellement
export const addPointsManually = (code) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'ADD_POINTS_REQUEST' });

    const { data } = await axios.post('/api/client/points/add-manual', {
      code
    });

    if (data.success) {
      dispatch({
        type: 'ADD_POINTS_SUCCESS',
        payload: data
      });

      // Mettre à jour les points dans le store
      dispatch({
        type: 'UPDATE_POINTS',
        payload: data.newPoints
      });

      // Mettre à jour localStorage
      localStorage.setItem('clientPoints', data.newPoints);

      // Rafraîchir les stats
      const clientId = getState().clientAuth.client?._id;
      if (clientId) {
        dispatch(getClientPoints(clientId));
      }

      dispatch(setMessage({
        type: 'success',
        text: data.message || 'Points ajoutés avec succès !'
      }));

      return { success: true, data };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de l\'ajout des points';
    
    dispatch({
      type: 'ADD_POINTS_FAIL',
      payload: errorMessage
    });

    dispatch(setMessage({
      type: 'error',
      text: errorMessage
    }));

    return { success: false, message: errorMessage };
  }
};

// Récupérer le catalogue de récompenses
export const getRewardsCatalog = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_REWARDS_REQUEST' });

    // Construire les query params
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });

    const url = `/api/rewards/catalog${params.toString() ? `?${params.toString()}` : ''}`;
    const { data } = await axios.get(url);

    if (data.success) {
      dispatch({
        type: 'GET_REWARDS_SUCCESS',
        payload: data.rewards
      });

      return { success: true, rewards: data.rewards };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur chargement récompenses';
    
    dispatch({
      type: 'GET_REWARDS_FAIL',
      payload: errorMessage
    });

    // Retourner des données par défaut pour le développement
    const defaultRewards = [
      {
        id: '1',
        name: "Café Express",
        description: "Un délicieux café express offert",
        pointsRequired: 200,
        category: "boissons",
        available: true,
        stock: 50
      },
      {
        id: '2',
        name: "Crêpe Nutella",
        description: "Crêpe garnie de Nutella",
        pointsRequired: 400,
        category: "nourriture",
        available: true,
        stock: 30
      }
    ];

    return { success: false, rewards: defaultRewards, message: errorMessage };
  }
};

// Échanger des points contre une récompense
export const redeemReward = (rewardId) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'REDEEM_REWARD_REQUEST' });

    const { data } = await axios.post('/api/client/points/redeem', {
      rewardId
    });

    if (data.success) {
      dispatch({
        type: 'REDEEM_REWARD_SUCCESS',
        payload: data
      });

      // Mettre à jour les points localement
      const currentPoints = getState().clientAuth.points;
      const pointsCost = data.reward?.pointsCost || 0;
      const newPoints = currentPoints - pointsCost;
      
      dispatch({
        type: 'UPDATE_POINTS',
        payload: newPoints
      });

      localStorage.setItem('clientPoints', newPoints);

      dispatch(setMessage({
        type: 'success',
        text: data.message || 'Récompense échangée avec succès !'
      }));

      return { success: true, data };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur échange récompense';
    
    dispatch({
      type: 'REDEEM_REWARD_FAIL',
      payload: errorMessage
    });

    dispatch(setMessage({
      type: 'error',
      text: errorMessage
    }));

    return { success: false, message: errorMessage };
  }
};

// Récupérer l'historique des transactions
export const getPointsHistory = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_HISTORY_REQUEST' });

    // Construire les query params
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });

    const url = `/api/client/points/history${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const { data } = await axios.get(url);

    if (data.success) {
      dispatch({
        type: 'GET_HISTORY_SUCCESS',
        payload: data.transactions
      });

      return { success: true, history: data.transactions };
    } else {
      throw new Error(data.message);
    }
    
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur historique';
    
    dispatch({
      type: 'GET_HISTORY_FAIL',
      payload: errorMessage
    });

    // Historique par défaut pour le développement
    const defaultHistory = [
      {
        id: '1',
        date: new Date().toISOString(),
        description: 'Achat SPINTOSS Tunisia Mall',
        points: 150,
        type: 'earned',
        billNumber: 'FAC-00123',
        location: 'Tunisia Mall'
      }
    ];

    return { success: false, history: defaultHistory, message: errorMessage };
  }
};

// Déconnexion client
export const logoutClient = () => (dispatch) => {
  // Supprimer les données locales
  localStorage.removeItem('clientToken');
  localStorage.removeItem('clientData');
  localStorage.removeItem('clientPoints');
  
  // Supprimer le header axios
  delete axios.defaults.headers.common['Authorization'];
  
  dispatch({ type: 'CLIENT_LOGOUT' });
  
  dispatch(setMessage({
    type: 'info',
    text: 'Déconnexion réussie'
  }));
};

// Mettre à jour les points localement
export const updatePointsLocal = (newPoints) => (dispatch) => {
  dispatch({
    type: 'UPDATE_POINTS',
    payload: newPoints
  });
  
  localStorage.setItem('clientPoints', newPoints);
};
// Dans ClientActions.js ou modifiez authActions.js
// Mettre à jour le profil client
export const updateClientProfile = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: 'UPDATE_CLIENT_PROFILE_REQUEST' });

    const token = localStorage.getItem('clientToken');
    
    if (!token) {
      throw new Error('Non authentifié. Veuillez vous reconnecter.');
    }

    console.log('📤 Mise à jour profil client:', clientData);

    const response = await fetch('/api/client/auth/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(clientData)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Erreur lors de la mise à jour');
    }

    if (data.success) {
      console.log('✅ Profil mis à jour avec succès:', data.client);

      // Mettre à jour le localStorage
      localStorage.setItem('clientData', JSON.stringify(data.client));

      // Dispatch pour mettre à jour le state
      dispatch({
        type: 'UPDATE_CLIENT_PROFILE_SUCCESS',
        payload: data.client
      });

      return { 
        success: true, 
        message: data.message || 'Profil mis à jour avec succès',
        client: data.client 
      };
    } else {
      throw new Error(data.message || 'Erreur inconnue');
    }
    
  } catch (error) {
    console.error('❌ Erreur updateClientProfile:', error);
    
    dispatch({
      type: 'UPDATE_CLIENT_PROFILE_FAIL',
      payload: error.message
    });

    return { 
      success: false, 
      message: error.message || 'Erreur de mise à jour du profil' 
    };
  }
};